import {z} from 'zod'

/** @typedef {z.infer<typeof Unit>} Unit */
export const Unit = z.object({
  id: z.coerce.string(),
  name: z.string(),
  desc: z.string().nullish(),
})
